import { Dialog } from '@mui/material'
import { PastTherapyReportDialogPaper } from 'src/clinic/components/ClinicManageBookingsPage/receiptPrinting/styledComponents'
import SendAssessmentComponent from 'src/clinic/components/ClinicManageBookingsPage/sendPrescriptionData/components/SendAssessmentComponent'
import SendTherapyComponent from 'src/clinic/components/ClinicManageBookingsPage/sendPrescriptionData/components/SendTherapyComponent'
import BookedEventLogsDrawer from 'src/clinic/components/ClinicManageBookingsPage/components/BookedEventLogsDrawer'
import JoiningDetails from 'src/clinic/components/ClinicManageBookingsPage/slotItem/component/JoiningDetails'
import PaymentLinksViewer from 'src/clinic/components/ClinicManageBookingsPage/slotItem/component/PaymentLinksViewer'
import NewBookingPopup from 'src/mentor/components/MentorClinicBookingsPage/component/newBooking/NewBookingPopup'
import { MENTOR_NEW_BOOKING_TABS } from 'src/mentor/components/MentorClinicBookingsPage/component/newBooking/newBookingConsts'
import TreatmentHistoryDrawer from 'src/clinic/components/ClinicManageBookingsPage/pastPatientReports/TreatmentHistoryDrawer'
import {
  StyledRequestTherapyComponent,
  StyledSendPrescriptionDataDialogPaper,
} from '../styledComponent'
import {
  PrescriptionDownloadOptionsDialog,
  ConfirmSendToPatientDialog,
} from './PrescriptionDownloadDialogs'
import SendPrescriptionData from 'src/clinic/components/ClinicManageBookingsPage/sendPrescriptionData/SendPrescriptionData'
import SendPrescriptionImagesDialog from 'src/clinic/components/ClinicManageBookingsPage/sendPrescriptionImages/SendPrescriptionImagesDialog'
import EmrImagesUploadDialog from 'src/clinic/components/ClinicManageBookingsPage/emrImagesUpload/EmrImagesUploadDialog'
import RescheduleSlotDialog from './RescheduleSlotDialog'
import SupportBookedEventRescheduleDrawer from 'src/supportPortal/components/bookings/SupportBookedEventRescheduleDrawer'

const BookedSlotDialogs = ({
  dialogs,
  bookedSlot,
  mentorProfileData,
  clinicLocationData,
  prescriptionGetApiSignature,
  prescriptionSaveApiSignature,
  fileUploadApiSignature,
  showGalleryForPrescriptionImages,
  sendSecureSessionLinkToPatientSignature,
  sendPublicSessionLinkToPatientSignature,
  prescriptionImagesGetApiSignature,
  prescriptionImagesSaveApiSignature,
  refreshBookedSlots,
  prescriptionDialogs,
  calculateCreatedTimeFrom,
  calculateCreatedTimeTo,
  showPatientHistoryInUploadPrescriptionWidget,
  patientHistoryGetApiSignature,
  emrImagesGetApiSignature,
  emrImagesSaveApiSignature,
  showSendingLinkButtonsToSupport,
  emrDialogTitle,
  emrImagesUploadImagesSignature,
  rescheduleDialogType = 'clinic-assistant',
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation() // Prevents Popover from closing
    }
  }

  return (
    <>
      {/* Send Therapy Dialog */}
      <Dialog
        open={dialogs.sendTherapy.isOpen}
        PaperComponent={StyledRequestTherapyComponent}
        maxWidth="lg"
        PaperProps={{
          onKeyDown: handleKeyDown,
        }}
        onClose={dialogs.sendTherapy.close}
      >
        <SendPrescriptionData
          bookedEventInfo={bookedSlot}
          closePopover={dialogs.sendTherapy.close}
          refreshBookedSlots={refreshBookedSlots}
          dialogTitle="Send Diagnosis To Therapist"
          InnerComponent={SendTherapyComponent}
          mentorProfileData={mentorProfileData}
        />
      </Dialog>

      {/* Treatment History Drawer */}
      <TreatmentHistoryDrawer
        open={dialogs.patientBooking.isOpen}
        onClose={dialogs.patientBooking.close}
        patientInfo={bookedSlot?.patientInfo}
        hideSendToDoctorButton={false}
        forceShowAllReports={true}
        patientHistoryGetApiSignature={patientHistoryGetApiSignature}
        referenceBookedEventId={bookedSlot?.id}
        bookedEventSlug={bookedSlot?.slug}
      />

      {/* Upload Prescription Images Dialog */}
      <SendPrescriptionImagesDialog
        open={dialogs.uploadPrescriptionImages.isOpen}
        bookedEventInfo={bookedSlot}
        closePopover={dialogs.uploadPrescriptionImages.close}
        mentorUserId={mentorProfileData?.userId}
        showPatientHistoryInUploadPrescriptionWidget={
          showPatientHistoryInUploadPrescriptionWidget
        }
        patientHistoryGetApiSignature={patientHistoryGetApiSignature}
        galleryImagesSearch={{
          createdTimeFrom: calculateCreatedTimeFrom(bookedSlot, clinicLocationData),
          createdTimeTo: calculateCreatedTimeTo(bookedSlot, clinicLocationData),
        }}
        showGallery={showGalleryForPrescriptionImages}
        fileUploadApiSignature={fileUploadApiSignature}
        prescriptionImagesGetApiSignature={prescriptionGetApiSignature}
        prescriptionImagesSaveApiSignature={prescriptionSaveApiSignature}
      />

      {/* Send Assessment Dialog */}
      <Dialog
        open={dialogs.sendAssessment.isOpen}
        maxWidth="sm"
        fullWidth
        PaperComponent={StyledSendPrescriptionDataDialogPaper}
        onClose={dialogs.sendAssessment.close}
      >
        <SendPrescriptionData
          bookedEventInfo={bookedSlot}
          closePopover={dialogs.sendAssessment.close}
          dialogTitle="Send Assessment To Psychologist"
          successMessage="Assessment sent successfully."
          refreshBookedSlots={refreshBookedSlots}
          InnerComponent={SendAssessmentComponent}
          mentorProfileData={mentorProfileData}
        />
      </Dialog>

      {/* Payment Links Dialog */}
      <Dialog
        open={dialogs.paymentLinks.isOpen}
        maxWidth="lg"
        fullWidth
        onClose={dialogs.paymentLinks.close}
      >
        <PaymentLinksViewer
          bookedSlot={bookedSlot}
          closeDialog={dialogs.paymentLinks.close}
          refreshBookedSlots={refreshBookedSlots}
        />
      </Dialog>

      {/* Joining Details Dialog */}
      <Dialog
        open={dialogs.joiningDetails.isOpen}
        maxWidth="lg"
        fullWidth
        onClose={dialogs.joiningDetails.close}
      >
        <JoiningDetails
          bookedEventInfo={bookedSlot}
          closeDialog={dialogs.joiningDetails.close}
          refreshBookedSlots={refreshBookedSlots}
          sendSecureSessionLinkToPatientSignature={sendSecureSessionLinkToPatientSignature}
          sendPublicSessionLinkToPatientSignature={sendPublicSessionLinkToPatientSignature}
          showSendingLinkButtonsToSupport={showSendingLinkButtonsToSupport}
        />
      </Dialog>

      {/* Booked Event Logs Drawer */}
      <BookedEventLogsDrawer
        open={dialogs.bookedEventLogs.isOpen}
        onClose={dialogs.bookedEventLogs.close}
        bookedSlot={bookedSlot}
      />

      {/* Prescription Download Dialogs */}
      <PrescriptionDownloadOptionsDialog
        open={prescriptionDialogs.showOptionsDialog}
        onClose={prescriptionDialogs.closeOptionsDialog}
        onDownloadOnly={prescriptionDialogs.handleDownloadOnly}
        onSendToPatient={prescriptionDialogs.handleSendToPatient}
        isLoading={prescriptionDialogs.isLoading}
      />
      <ConfirmSendToPatientDialog
        open={prescriptionDialogs.showConfirmDialog}
        onClose={prescriptionDialogs.closeConfirmDialog}
        onConfirm={prescriptionDialogs.handleConfirmedSendToPatient}
        isLoading={prescriptionDialogs.isLoading}
      />

      {/* EMR Images Upload Dialog */}
      <EmrImagesUploadDialog
        open={dialogs.emrImages.isOpen}
        bookedEventInfo={bookedSlot}
        closePopover={dialogs.emrImages.close}
        showGallery={showGalleryForPrescriptionImages}
        mentorUserId={mentorProfileData?.userId}
        galleryImagesSearch={{
          createdTimeFrom: calculateCreatedTimeFrom(bookedSlot, clinicLocationData),
          createdTimeTo: calculateCreatedTimeTo(bookedSlot, clinicLocationData),
        }}
        fileUploadApiSignature={emrImagesUploadImagesSignature}
        showPatientHistoryInUploadPrescriptionWidget={showPatientHistoryInUploadPrescriptionWidget}
        patientHistoryGetApiSignature={patientHistoryGetApiSignature}
        dialogTitle={emrDialogTitle}
        emrImagesGetApiSignature={emrImagesGetApiSignature}
        emrImagesSaveApiSignature={emrImagesSaveApiSignature}
      />

      {rescheduleDialogType === 'support' ? (
        <SupportBookedEventRescheduleDrawer
          open={dialogs.reschedule.isOpen}
          bookedEvent={bookedSlot}
          onClose={dialogs.reschedule.close}
          onSuccess={() => {
            dialogs.reschedule.close()
            refreshBookedSlots?.()
          }}
        />
      ) : (
        <RescheduleSlotDialog
          open={dialogs.reschedule.isOpen}
          onClose={dialogs.reschedule.close}
          bookedSlot={bookedSlot}
          refreshBookedSlots={refreshBookedSlots}
        />
      )}
    </>
  )
}

export default BookedSlotDialogs
